import { changeIssueAccess } from 'serviceWorker/services/issues/accesses';
import { createIssueEvent, editIssueEvent, removeIssueEvent } from 'serviceWorker/services/issues/events';
import { issueSource } from 'serviceWorker/services/issues/issueSource';
import {
  exportDocumentToDocumentation,
  importFromDocumentation,
  removeLinkedDocumentation,
} from 'serviceWorker/services/issues/linkedDocumentation';
import {
  getIncomingEmailMessageContent,
  getIssueChangelog,
  getShareableUrl,
} from 'serviceWorker/services/issues/serverReads';
import { queueIssueChanges } from 'serviceWorker/services/issues/queueIssueChanges';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { issueContract } from 'shared/domain/issue/issueContract';
import { runWhenRequestsAllowed } from './runWhenRequestsAllowed';
import { syncWithPermissions } from './serveEntityRequests';

/**
 * Answers the issue requests: reads once the issues are downloaded, changes
 * once queued (their outcome follows as an event with the change's `uniqueId`),
 * linked documentation, events and accesses once the server saved them;
 * email contents, shareable links and the changelog straight from the server.
 */
export function serveIssueRequests(): ChannelUnsubscribe {
  return channelServer.handle(issueContract, {
    getOneById: ({ id }) => issueSource.getOneById(id),
    getFiltered: issueSource.getFiltered,
    getFilteredIdList: issueSource.getFilteredIdList,
    getOfInspection: ({ inspectionId, timezone }) => issueSource.getOfInspection(inspectionId, timezone),
    ...queueIssueChanges,
    exportToDocumentation: exportDocumentToDocumentation,
    importFromDocumentation,
    removeLinkedDocumentation,
    createEvent: createIssueEvent,
    editEvent: editIssueEvent,
    removeEvent: removeIssueEvent,
    changeAccess: changeIssueAccess,
    getIncomingEmailMessageContent,
    getShareableUrl,
    getChangelog: getIssueChangelog,
    sync: () => runWhenRequestsAllowed(() => syncWithPermissions(issueSource.sync)),
  });
}
